import { ReactNode } from "react";
import { ExpireSessionOn401 } from "./ExpireSessionOn401";
import { ExpireSessionOnInactivity } from "./ExpireSessionOnInactivity";

const Authed = ({ children }: { children: ReactNode }) => (
  <ExpireSessionOnInactivity>
    <ExpireSessionOn401>
        {children}
    </ExpireSessionOn401>
  </ExpireSessionOnInactivity>
);

export default Authed;
